import {getProfiles} from "../../../services/ondemandApi"
import { navigateToSessionExpired } from "../../../utils/sessionExpired";

export const handlerGetProfiles = async (navigate, setProfileList, changeProfile, redirectToDocument, profileType, serviceIdentifier, setProfilePageHeader, setProfilePageDescription) => {
    try {

        let response = await getProfiles(changeProfile, profileType, serviceIdentifier);
        if (!response.status) {
            navigateToSessionExpired(navigate, {
                reason: "profile_list_invalid_response",
                source: "handlerGetProfiles",
                component: "ListProfiles",
            })
            return
        }

        sessionStorage.setItem('transportType', `${response.result.vehicleType}`)

        if (response.status && response.result.profileCount === 1 && (profileType === "" || profileType === null)) {
            sessionStorage.setItem('selectedProfileType', JSON.stringify(response.result.profileList[0]))
            sessionStorage.setItem('redirectToDocument', redirectToDocument)
            navigate('/documents')
            return
        }

        if(profileType !== "") {
            generateProfilePageWordings(setProfilePageHeader, setProfilePageDescription, profileType, serviceIdentifier)
        }

        setProfileList(response.result.profileList)
        return

    } catch (err) {
        console.log("Err while getting profile list", err.message)
    }
}

export const handleProfileSelection = (profile, navigate) => {
    sessionStorage.setItem('selectedProfileType', JSON.stringify(profile))
    navigate('/documents')
}

export const generateProfilePageWordings = (setProfilePageHeader, setProfilePageDescription, profileType, serviceTypeIndicator) => {

    const servicenameKey = {
        "rydex" : "RydeX",
        "rydexl" : "RydeXL",
        "rydeluxe" : "RydeLuxe",
        "taxi" : "Ryde Taxi",
        "rydeexec": "RydeLuxe" ,
        "rydetaxi": "Ryde Taxi",
    }

    if(profileType === "pool") {
        setProfilePageHeader(() => `To be eligible for ${servicenameKey[serviceTypeIndicator]} Service`)
        setProfilePageDescription(() => "You must first undergo verfication as a PDVL/TDVL driver. You can initiate the application process through the options provided below: ")
    }
    if(profileType === "pdvl") {
        setProfilePageHeader(() => `To be eligible for ${servicenameKey[serviceTypeIndicator]} Service`)
        setProfilePageDescription(() => "You must first undergo verfication as a TDVL driver. You can initiate the application process through the options provided below: ")
    }
}
